/* eslint-disable import/extensions */
import Router from 'next/router';
import { usePathname } from 'next/navigation';
import React from 'react';
import { Badge, NavDropdown } from 'react-bootstrap';
import { FaRightFromBracket, FaHandSparkles, FaWarehouse, FaBell, FaBullhorn, FaTriangleExclamation, FaSeedling, } from 'react-icons/fa6';
import { format, layout, profile, store } from '@/helpers/index';
import { auth } from '@/services/auth';
import { constant } from '@/helpers/constant';

export default function DropdownProfileMenu({ ignoreBalance, align }) {
  const pathname = usePathname();
  const user = auth.store.logged.get();
  const notifications = store.notifications.updates.get() ?? {};
  const hours = new Date().getHours();
  let greeting = hours < 12 ? 'Bom dia' : 'Boa tarde';
  if (hours >= 18 && hours <= 23) {
    greeting = 'Boa noite';
  }

  const balance = () => {
    if (!user) { return ''; }
    return `. Saldo: ${format.currency(user.balance)}`;
  };

  const title = () => {
    if (!user) { return ''; }
    return `${greeting}, ${format.capitalize(user?.acronym)}${(!user?.partner || user?.prepaid) && !ignoreBalance ? balance() : '!'}`;
  };

  const handleTab = (primary, secondary) => {
    store.set('mix-tab', primary);
    store.set('manager-mix-tab', secondary);
    window.location.href = '/crm/mix';
  };

  return (
    <>
      {user && profile.canManager(user) && (
        <NavDropdown title={(
          <>
            <FaBell />
            <Badge bg="danger" className={`badge-notification rounded-pill${notifications.issues > 0 || notifications.communications > 0 ? ' blink-me' : ''}`}>{notifications.communications + notifications.issues}</Badge>
          </>
        )} id="notification" className="not-printable display-inline-block me-2" align={align}>
          {notifications.communications > 0 && (
            <NavDropdown.Item onClick={() => handleTab('manager', 'communications')}>
              <FaBullhorn className="me-1" />
              Comunicações de Venda
              <Badge bg="danger" className="badge-notification rounded-pill">{notifications.communications}</Badge>
            </NavDropdown.Item>
          )}
          {notifications.issues > 0 && (
            <NavDropdown.Item onClick={() => handleTab('monitoring', 'openIssues')}>
              <FaTriangleExclamation className="me-1" />
              Pendências
              <Badge bg="danger" className="badge-notification rounded-pill">{notifications.issues}</Badge>
            </NavDropdown.Item>
          )}
        </NavDropdown>
      )}
      {user && (
        <NavDropdown title={title()} id="user" className="not-printable display-inline-block" align={align}>
          {user && profile.isLeads(user) && (
            <NavDropdown.Item onClick={() => { layout.loading(true); Router.push(constant.redirect.leads); }} active={pathname === constant.redirect.leads}>
              <FaSeedling className="me-1" />
              Meus Leads
            </NavDropdown.Item>
          )}
          <NavDropdown.Item onClick={() => { layout.loading(true); Router.push(constant.redirect.customer); }} active={pathname === constant.redirect.customer}>
            <FaWarehouse className="me-1" />
            Minha Área
          </NavDropdown.Item>
          <NavDropdown.Divider />
          {user && profile.canManager(user) && (
            <>
              <NavDropdown.Item onClick={() => { layout.loading(true); Router.push(constant.redirect.mix); }} active={pathname === constant.redirect.mix}>
                <FaHandSparkles className="me-1" />
                MIX
              </NavDropdown.Item>
              <NavDropdown.Divider />
            </>
          )}
          <NavDropdown.Item onClick={() => auth.logout(() => Router.push('/'))}>
            <FaRightFromBracket className="me-1" />
            Sair
          </NavDropdown.Item>
        </NavDropdown>
      )}
    </>
  );
}
